import { Star, ArrowUpRight } from "lucide-react";

const REVIEWS_URL = "https://share.google/J9vnsecuRUnuCadt4";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 lg:py-28"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10">
        <div className="reveal text-center">
          <div className="text-[0.6rem] uppercase tracking-[0.32em] mb-3" style={{ color: "#B89968" }}>
            Words From Clients
          </div>
          <h2
            className="font-serif font-light leading-[0.95]"
            style={{ color: "#161618", fontSize: "clamp(2.5rem, 6vw, 4.75rem)", letterSpacing: "0.02em" }}
          >
            Reviews
          </h2>
          <div
            className="mt-5 font-serif italic"
            style={{ color: "#B89968", fontSize: "clamp(1.25rem, 2.4vw, 1.85rem)" }}
          >
            Honest words from real clients.
          </div>
          <div className="flex items-center justify-center gap-3 mt-6">
            <span className="h-px w-12" style={{ background: "#B89968" }} />
            <span className="text-xs" style={{ color: "#B89968" }}>♥</span>
            <span className="h-px w-12" style={{ background: "#B89968" }} />
          </div>
          <p
            className="mt-7 max-w-xl mx-auto text-[#4D4A47] font-light text-lg leading-relaxed"
          >
            Verified and updated in real time on Google.
          </p>

          <div className="mt-12 inline-flex items-center gap-5 flex-wrap justify-center">
            <a
              href={REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-link"
              className="btn-primary inline-flex"
            >
              Reviews
              <ArrowUpRight className="w-4 h-4" />
            </a>
            <div className="inline-flex items-center gap-1" aria-label="5 star rating">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className="w-6 h-6"
                  style={{ fill: "#D4AF37", color: "#D4AF37" }}
                />
              ))}
            </div>
          </div>

          <p className="mt-8 text-[0.6rem] uppercase tracking-[0.3em] text-[#8C8580]">
            Opens Google in a new tab
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
